import { noop } from 'lodash-es';

/**
 * When hot module replacement occurs, the map instance is lost.
 * This empty map prevents errors when accessing the map before re-initialization.
 */
export const emptyMap = {
  on: noop,
  off: noop,

  getContainer: () => document.createElement('div'),
  getCanvas: () => document.createElement('canvas'),
  getCanvasContainer: () => document.createElement('div'),

  getZoom: () => 0,
} as unknown as mapboxgl.Map;
